export default __webpack_public_path__ + "static/media/1295.36394ad3.png";